import React, { useCallback, useEffect, useMemo, useState } from "react";
import { LearnWorkbenchShell } from "../components/layout/LearnWorkbenchShell";
import { ScaleHubLibrary } from "../components/scales/hub/ScaleHubLibrary";
import { ScaleRecorridoStudio } from "../components/scales/hub/ScaleRecorridoStudio";
import { ScaleCagedStudio } from "../components/scales/hub/ScaleCagedStudio";
import { getScaleHubCardById } from "../lib/scales/scaleHubPlan";
import {
  loadScaleHubProgress,
  markScaleHubCardComplete,
  saveScaleHubProgress,
} from "../lib/scales/scaleHubProgress";

export const ScaleHubPage: React.FC = () => {
  const [activeCardId, setActiveCardId] = useState<string | null>(null);
  const [progress, setProgress] = useState(loadScaleHubProgress);
  const [celebrateCardId, setCelebrateCardId] = useState<string | null>(null);

  const activeCard = useMemo(
    () => (activeCardId ? getScaleHubCardById(activeCardId) : null),
    [activeCardId]
  );

  useEffect(() => {
    saveScaleHubProgress(progress);
  }, [progress]);

  const handleSelectCard = useCallback((cardId: string) => {
    setActiveCardId(cardId);
  }, []);

  const handleBackToHub = useCallback(() => {
    setActiveCardId(null);
  }, []);

  const handleComplete = useCallback((cardId: string) => {
    setProgress((p) => markScaleHubCardComplete(p, cardId));
    setActiveCardId(null);
    setCelebrateCardId(cardId);
    window.setTimeout(() => setCelebrateCardId(null), 2200);
  }, []);

  if (activeCard?.studioKind === "scale-recorrido") {
    return (
      <ScaleRecorridoStudio
        card={activeCard}
        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}
        onBack={handleBackToHub}
        onComplete={() => handleComplete(activeCard.id)}
      />
    );
  }

  if (activeCard?.studioKind === "caged-pattern") {
    return (
      <ScaleCagedStudio
        card={activeCard}
        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}
        onBack={handleBackToHub}
        onComplete={() => handleComplete(activeCard.id)}
      />
    );
  }

  return (
    <LearnWorkbenchShell
      activeModule="scales"
      hideLeftSidebar
      sidebar={<div />}
      className="min-h-[100dvh] h-[100dvh]"
    >
      <ScaleHubLibrary
        progress={progress}
        celebrateCardId={celebrateCardId}
        onSelectCard={handleSelectCard}
      />
    </LearnWorkbenchShell>
  );
};

export default ScaleHubPage;
